// extracted by mini-css-extract-plugin
export default {"JobCard":"jobCardSkeleton_JobCard__zGkAn"};